/**
 * @generated SignedSource<<795b9a938f1da3e4a4f332fb12c6c5c9>>
 * @relayHash f02e146546f3b823544a355d70cd3e00
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a57d53ea1cdaee494e19e5eee8c714c93ae8b61ea2d55b2ea77cb1c5f03522ca

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { boardFilterRefinementQuery } from './boardFilterRefinementQuery.graphql';

const node: PreloadableConcreteRequest<boardFilterRefinementQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a57d53ea1cdaee494e19e5eee8c714c93ae8b61ea2d55b2ea77cb1c5f03522ca",
    "metadata": {},
    "name": "boardFilterRefinementQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
